import { render, staticRenderFns } from "./GetGoods.vue?vue&type=template&id=230459bd&scoped=true"
import script from "./GetGoods.vue?vue&type=script&lang=js"
export * from "./GetGoods.vue?vue&type=script&lang=js"
import style0 from "./GetGoods.vue?vue&type=style&index=0&id=230459bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230459bd",
  null
  
)

export default component.exports